import React from "react";
import MetaTagContents from "../../MetaTagContents";
import { Helmet } from "react-helmet";
import NavBar from "../landingPage/header/navbar";
import Footer from "../landingPage/footer";
import Content from "./Content";
import { Layout } from "antd";

const PricingPage = () => {
  const { name, content } = MetaTagContents.SUBSCRIPTION_PLANS;
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{MetaTagContents.SUBSCRIPTION_PLANS.title}</title>
        <link rel="canonical" href="https://all3d.ai/pricing" />
        <meta name={name} content={content} />
      </Helmet>
      <NavBar />
      <Layout>
        <Content />
      </Layout>
      <Footer />
    </>
  );
};

export default PricingPage;
